const Company = {
  list: async function(params) {
    const authToken = await localStorage.getItem("token");
    let url = `${process.env.REACT_APP_API_BASE_URL}/support/company`;
    if (params) {
      let query_params = new URLSearchParams(params).toString();
      url = url + `?${query_params}`;
    }

    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken
      })
    });
    const response = await fetch(request);
    const json = await response.json();
    return { data: json.data, total: json.pagination.total };
  },
  create: async function(company_uuid, company) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/company`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(company)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  update: async function(uuid, company) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/company/${uuid}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(company)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  delete: async function(uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/company/${uuid}`,
      {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        })
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  load: async function(uuid) {
    const authToken = await localStorage.getItem("token");
    var url = `${process.env.REACT_APP_API_BASE_URL}/support/company/${uuid}`;
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken
      })
    });
    const response = await fetch(request);
    const json = await response.json();
    return json.data;
  },
  export_time_entries: async function (company_uuid, { limit = 15000, offset = 0 } = {}) {
    const authToken = await localStorage.getItem("token");

    const query = new URLSearchParams({
      company_uuid,
      limit,
      offset
    }).toString();

    const url = `${process.env.REACT_APP_API_BASE_URL}/timesheet/support/export_entries?${query}`;
    const response = await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: authToken
      })
    });

    if (!response.ok) {
      throw new Error(`Export failed: ${response.statusText}`);
    }

    // API Gateway returns binary; fetch gives us a Blob
    return await response.blob(); // caller can saveAs / createObjectURL
  }
};

export default Company;